let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d5GjE")).then(() => parcelRequire('3ahnS'));